export function LogoIcon({ size = 32, className = "" }) {
  return (
    <img
      src="/last_logo.png"
      alt="LiveBetter"
      width={size}
      height={size}
      className={className}
      style={{ width: size, height: size, objectFit: "contain" }}
    />
  );
}

export function LogoFull({ iconSize = 36, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoIcon size={iconSize} />
      <span className="text-xl font-bold tracking-tight transition-colors duration-300" style={{ fontFamily: "Outfit", color: "var(--lb-text)" }}>
        LiveBetter
      </span>
    </div>
  );
}

export function LogoWithTagline({ iconSize = 44, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <LogoIcon size={iconSize} />
      <div className="flex flex-col">
        <span className="text-2xl font-bold tracking-tight transition-colors duration-300" style={{ fontFamily: "Outfit", color: "var(--lb-text)" }}>
          LiveBetter
        </span>
        <span className="text-[10px] tracking-[0.15em] uppercase font-medium transition-colors duration-300" style={{ color: "var(--lb-text-muted)" }}>
          Your compassionate path to wellbeing
        </span>
      </div>
    </div>
  );
}
